import React from 'react';
import { theme } from '../../../../db.json';
import { ContainerMenu, ContainerMenuButtons } from '../../../../components/Containers';
import ButtonMainContainer from '../../../../components/Home/MainContainer/ButtonMainContainer';

export default function TemplateContabil() {
  const themeColors = theme.colors.systems;
  return (
    <ContainerMenu>
      <ContainerMenuButtons>
        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Contabil}
          name="Relatórios Contábeis"
          link="/novo-sistema/contabil/relatorios-contabeis"
          linkImg="/images/icons/buttons/paperFill.svg"
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Contabil}
          name="Obrigações Acessórias"
          link="/novo-sistema/contabil/obrigacoes-acessorias"
          linkImg="/images/icons/buttons/information.svg"
        />
      </ContainerMenuButtons>
    </ContainerMenu>
  );
}
